// extracted by mini-css-extract-plugin
export default {"simpleSelector":"SelectorSimple_simpleSelector__SdK0y","triangle":"SelectorSimple_triangle__NsOs-","rotateTriangle":"SelectorSimple_rotateTriangle__GO+Dv"};